import { ResetPasswordComponent } from './reset-password.component'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { MetaGuard } from 'meta'

import { SegmentTagMap } from '../shared/analytics/models/segment-tag-map.model'

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: ResetPasswordComponent,
        canActivate: [MetaGuard],
        data: {
          shouldShowEventTicker: false,
          segment: SegmentTagMap.FORGOT_PASSWORD,
          meta: {
            title: 'Forgot Password'
          }
        }
      },
      {
        path: ':token',
        component: ResetPasswordComponent,
        canActivate: [MetaGuard],
        data: {
          shouldShowEventTicker: false,
          segment: SegmentTagMap.RESET_PASSWORD,
          meta: {
            title: 'Reset Password'
          }
        }
      }
    ])
  ],
  exports: [RouterModule]
})
export class ResetPasswordRoutingModule {}
